module.exports = __webpack_public_path__ + "img/dashboard-arrow-down.447a5a2d.svg";